
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 60 60","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M49.688 7.5H39.374V5.625A5.625 5.625 0 0033.75 0h-7.5a5.625 5.625 0 00-5.625 5.625V7.5H10.312a4.688 4.688 0 00-4.687 4.688v3.75c0 1.035.84 1.874 1.875 1.874h45c1.036 0 1.875-.839 1.875-1.875v-3.75A4.688 4.688 0 0049.687 7.5zM24.375 5.625c0-1.034.841-1.875 1.875-1.875h7.5c1.034 0 1.875.841 1.875 1.875V7.5h-11.25V5.625zM9.184 21.563a.586.586 0 00-.585.613l1.547 32.466A5.618 5.618 0 0015.764 60h28.474a5.618 5.618 0 005.618-5.358l1.547-32.466a.586.586 0 00-.585-.613H9.184zm28.317 4.687a1.874 1.874 0 113.75 0v24.375a1.875 1.875 0 11-3.75 0V26.25zm-9.375 0a1.874 1.874 0 113.75 0v24.375a1.875 1.875 0 11-3.75 0V26.25zm-9.375 0a1.874 1.874 0 113.75 0v24.375a1.875 1.875 0 11-3.75 0V26.25z"}})])
          )
        }
      }
    